export class LocationUpdate {
    address: string;
    elevation: number;

    constructor(address: string, elevation: number) {
        this.address = address;
        this.elevation = elevation;
    }
}
